import { render, staticRenderFns } from "./RecipePreparation.vue?vue&type=template&id=6c7bbd96&scoped=true"
import script from "./RecipePreparation.vue?vue&type=script&lang=js"
export * from "./RecipePreparation.vue?vue&type=script&lang=js"
import style0 from "./RecipePreparation.vue?vue&type=style&index=0&id=6c7bbd96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7bbd96",
  null
  
)

export default component.exports